import { render, staticRenderFns } from "./TeacherCardDetail.vue?vue&type=template&id=13bf69c8&scoped=true&"
import script from "./TeacherCardDetail.vue?vue&type=script&lang=js&"
export * from "./TeacherCardDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardDetail.vue?vue&type=style&index=0&id=13bf69c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf69c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
